import "./css/ChainWarningCard.scss"
import metamask from "./img/metamask.svg"
import React from "react"
const ChainWarningCard = React.memo(() => {
    return (
        <div className="card-background">
            <div className="card-container connect-card">
                <img src={metamask} alt="metamask icon" />
                <div id="connect-text">You're currently on an unsupport chain <br/> please switch to Ethereum mainnet, Polygon, Avalanche to continue.</div>
            </div>
        </div>
    )
})
export default ChainWarningCard